class Cart {
  cartObject = null;

  constructor(cartObject) {
    this.cartObject = cartObject;
    Object.freeze(cartObject);
  }

  getId() {
    throw new Error("Not implemented");
  }

  getItems() {
    throw new Error("Not implemented");
  }

  getNumberOfItems() {
    throw new Error("Not implemented");
  }

  getPrices() {
    throw new Error("Not implemented");
  }

  getTaxDetails() {
    throw new Error("Not implemented");
  }

  hasDiscount() {
    throw new Error("Not implemented");
  }

  getItem(product) {
    throw new Error("Not implemented");
  }

  isInCart(product) {
    throw new Error("Not implemented");
  }

  getPromoCode() {
    throw new Error("Not implemented");
  }

  getPromoCodes() {
    throw new Error("Not implemented");
  }

  hasItems() {
    throw new Error("Not implemented");
  }

  clone() {
    throw new Error("Not implemented");
  }
}

export default Cart;
